var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('info-text',{attrs:{"resource":_vm.resource,"crud-type":"edit"}}),_c('va-edit-layout',{attrs:{"title":_vm.title}},[_c('companies-form',{attrs:{"id":_vm.id,"item":_vm.item,"isEdit":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }